<template>
    <el-dialog class="recommend-resume-dialog"  title="推荐简历" :visible.sync="showDialog">
        <div class="content-confirm border-radius" :key="preventKey+'a'">
            <h1 class="text-center">候选人信息</h1>
            <el-row v-if="isSingle">
                <el-col>
                    <p>
                        <span>候选人：{{ confirmInfo.name }}</span>
                        <span class="ml-20">性别：{{ getSelectMapText('WB_GENDER', confirmInfo.gender) || '-'}}</span>
                        <span class="ml-20">手机号：{{ confirmInfo.phone }}</span>
                        <span class="ml-20">邮箱：{{ confirmInfo.email }}</span>
                    </p>
                    <p class="mt-10">当前职位：{{ confirmInfo.position }}</p>
                </el-col>
            </el-row>
            <el-table v-else :data="multiConfirmInfo">
                <el-table-column label="候选人" prop="resumeForm.name" :show-overflow-tooltip="true" align="center"
                                 min-width="80"></el-table-column>
                <el-table-column label="性别" :show-overflow-tooltip="true" align="center" min-width="50">
                    <template slot-scope="scope">{{ getSelectMapText('WB_GENDER', scope.row.resumeForm.gender) || '-'}}</template>
                </el-table-column>
                <el-table-column label="手机号" prop="resumeForm.mobilePhone" :show-overflow-tooltip="true" align="center"
                                 min-width="80"></el-table-column>
                <el-table-column label="邮箱" prop="resumeForm.email" :show-overflow-tooltip="true" align="center"
                                 min-width="80"></el-table-column>
                <el-table-column label="当前职位" prop="positionForm.name" :show-overflow-tooltip="true" align="center"
                                 min-width="100"></el-table-column>
            </el-table>
        </div>
        <div class="recommend-wrap border-radius">
            <el-tabs class="recommend-tabs" type="border-card" v-model="ruleForm.noticeType">
                <el-tab-pane label="邮件" name="1"></el-tab-pane>
                <el-tab-pane label="POPO推送" name="0"></el-tab-pane>
            </el-tabs>
            <component :is="'el-form'" :model="ruleForm" :rules="rules" ref="ruleForm" :key="preventKey+'b'" class="form-beauty"
                    label-width="100px">
                <el-form-item label="推荐职位" :prop="isSingle ? 'positionId' : ''">
                    <transfer-select :positionList="positionList" v-model="ruleForm.positionId" />
                </el-form-item>
                <el-form-item label="评估人" prop="evaluator">
                    <user-search ref="evaluator" v-model="ruleForm.evaluator"></user-search>
                </el-form-item>
                <el-form-item label="抄送人" prop="ccs" v-show="ruleForm.noticeType === '1'">
                    <user-search ref="ccs" v-model="ruleForm.ccList"></user-search>
                </el-form-item>
                <el-form-item label="推荐说明" prop="reason">
                    <el-input v-model="ruleForm.reason" type="textarea" :autosize="{ minRows: 3, maxRows: 6}"
                            resize="none"></el-input>
                </el-form-item>
            </component>
        </div>
        <div slot="footer">
            <el-button @click="showDialog = false">取消</el-button>
            <el-button type="primary" @click="submitForm('ruleForm')">发送{{ ruleForm.noticeType === '1' ? '邮件' : 'POPO消息' }}</el-button>
        </div>
    </el-dialog>
</template>

<script type="text/javascript">
    import fetchPositionListMixin from './fetchPositionListMixin'
    import jobTransfer from './jobTransfer'
    import UserSearch from 'components/userSelect/searchDownList'
    import selectMapMixin from 'mixins/selectMapMixin'
    import formCommonMixin from 'mixins/formCommonMixin'

    export default {
        mixins: [fetchPositionListMixin, selectMapMixin, formCommonMixin],
        extends: jobTransfer,
        watch: {
            'positionList' (nv, ov) {
                if (this.positionList && this.positionList.length > 0) {
                    let idList = this.positionList.map(cv => cv.value)
                    if (!idList.includes(this.ruleForm.positionId)) {
                        this.ruleForm.positionId = ''
                    }
                }
            }
        },
        data () {
            return {
                showDialog: false,
                isSingle: true,
                confirmInfo: {
                    name: '',
                    gender: '',
                    phone: '',
                    email: '',
                    position: ''
                },
                multiConfirmInfo: [],
                preventKey: 1,
                ruleForm: {
                    positionId: '',
                    evaluator: '',
                    ccList: '',
                    ids: '',
                    reason: '',
                    noticeType: '1'
                },
                rules: {
                    positionId: {required: true, message: '请选择', trigger: 'change'},
                    evaluator: {required: true, message: '请输入搜索', trigger: 'blur,change'},
                    reason: {required: true, message: '请输入', trigger: 'blur'}
                }
            }
        },
        methods: {
            show (data, single = true) {  // true/false:单个/多个
                this.preventKey = +new Date()
                this.isSingle = single
                // 仅获取已发布职位
                this.fetchPositionList(true)
                if (this.isSingle) {
                    this.confirmInfo = {
                        name: data.resumeForm.name,
                        gender: data.resumeForm.gender,
                        phone: data.resumeForm.mobilePhone,
                        email: data.resumeForm.email,
                        position: data.positionForm.name
                    }
                    this.ruleForm.positionId = data.positionForm.id + ''
                    this.ruleForm.ids = data.id
                } else {
                    this.multiConfirmInfo = data
                    this.ruleForm.ids = data.map(item => item.id).join(',')
                    this.ruleForm.positionId = ''
                }
                this.ruleForm.evaluator = ''
                this.ruleForm.ccList = ''
                this.ruleForm.reason = ''
                this.showDialog = true
            },
            saveForm (boolean) {
                this.$axios.post('/resumePosition/changePosition.api', this.ruleForm, {'X-showMessage': true}).then(res => {
                    this.showDialog = false
                    this.$emit('reload')
                }).catch(console.error)
            }
        },
        components: {
            UserSearch
        }
    }
</script>

<style type="text/css" lang="scss">
    @import "~variable";

    .recommend-resume-dialog {
        .content-confirm {
            background-color : $color-primary;
            color            : white;
            margin           : 0 20px 20px;
            > h1 {
                font-size : 18px;
                padding   : 15px;
            }
            > .el-row {
                background-color : #59a0ff;
                padding          : 15px;
                border-radius    : 0 0 $border-radius $border-radius;
            }
        }
        .recommend-wrap {
            border: 1px solid #dcdfe6;
            margin: 0 20px;
            padding: 1px 0;
            box-shadow: 0 2px 4px 0 #0000001f;
        }
        .recommend-tabs {
            border: 0;
            box-shadow: none;
            .el-tabs__content {
                display: none;
            }
        }
        .el-form {
            margin: 0 20px;
            padding: 15px 0 0;
        }
    }
</style>



// WEBPACK FOOTER //
// recommendResumeDialog.vue?82841cf6